type Game = { slug: string; coverImage?: string };

// Artwork selection is independent of the editable game name.
const coastalArtwork = new Set([
  'sheep-meadow-2',
  'bubble-carnival',
  'skybreaker-stage1',
  'alpine-rush-2',
  'dragonfall',
  'sudoku',
  'taixu',
  'fruit-island',
  'midnight-pool',
  'sunlight-garden-defense',
  'rich-island',
  'shiba-hide-seek',
  'tideline',
]);
// Package upgrades may version the sheep game's slug; keep its visual identity.
const artSlug = (slug: string) => (/^sheep-meadow(?:-\d+)?$/.test(slug) ? 'sheep-meadow-2' : slug);

export function gameCover(game: Pick<Game, 'slug' | 'coverImage'>) {
  return coastalArtwork.has(artSlug(game.slug))
    ? `/art/coastal-v1/${artSlug(game.slug)}.webp`
    : game.coverImage;
}
export function gameHero(game: Pick<Game, 'slug' | 'coverImage'>) {
  if (artSlug(game.slug) === 'sheep-meadow-2') return '/art/coastal-v1/sheep-hero.webp';
  if (['bubble-carnival', 'skybreaker-stage1'].includes(game.slug))
    return `/art/coastal-v1/${game.slug}-hero.webp`;
  return gameCover(game);
}
